export default __webpack_public_path__ + "static/media/Hazelnut-Heritage-3.f501a43a.jpg";